import { Opstartplan, useGetDossierOpstartplanById } from "@/entities/opstartplan";
import { useGetDossierVsmById } from "@/entities/vsm";
import { DossierSummaryCard, DossierSummaryCardSkeleton } from "@/features/dossier-details";
import { OpstartplanSummary } from "@/features/opstartplan";
import { VsmSummary } from "@/features/vsm";
import { EmptyState } from "@/shared/components";
import { formatDateTimeRelative } from "@/shared/utils";

interface VsmSOfOpstartplanSummaryProps {
    dossierNummer: string;
}

export function VsmOfOpstartplanSummary({ dossierNummer }: Readonly<VsmSOfOpstartplanSummaryProps>) {
    const { data: opstartplan, isPending: opstartplanPending, error: opstartplanError } = useGetDossierOpstartplanById(dossierNummer);
    const { data: vsm, isPending: vsmPending, error: vsmError } = useGetDossierVsmById(dossierNummer);

    if (opstartplanPending || vsmPending) {
        return <DossierSummaryCardSkeleton section="VsmOfOpstartplan" />;
    }

    if (opstartplanError) {
        return <p>Fout bij het laden van opstartplan: {opstartplanError.message}</p>;
    }

    if (vsmError) {
        return <p>Fout bij het laden van vsm: {vsmError.message}</p>;
    }

    let content = null,
        status: string | undefined;
    if (opstartplan && opstartplan?.treinseries?.length) {
        content = <OpstartplanSummary opstartplan={opstartplan} />;
        const firstVertrekDatumTijd = Opstartplan.getFirstVertrekDatumTijd(opstartplan);
        status = `Opstartplan | 1e trein: ${formatDateTimeRelative(firstVertrekDatumTijd)}`;
    } else if (vsm) {
        content = <VsmSummary vsm={vsm} />;
        status = `VSM ${vsm.vsmStatus}`;
    }

    const hasContent = content != null;

    return (
        <DossierSummaryCard section="VsmOfOpstartplan" status={status}>
            {hasContent ? content : <EmptyState className="pr-3 pl-4">Geen versperringsmaatregel of opstartplan beschikbaar</EmptyState>}
        </DossierSummaryCard>
    );
}
